import axios from 'axios';

import { BASE_API_URL } from '../_services';
import { userService } from '../_services';
import { authHeader, router } from '../_helpers';
import { store } from '../_store/index';


function handleResponse(error) {
    if (error.response.status == 401) {
      store.dispatch('alert/error', {message: 'Your session has expired.'}, { root: true });
      userService.logout()
      router.push('/login')
    } else if (error.response.status == 403) {
      store.dispatch('alert/error', {message: 'Your vet user code has not been set in EzyVet please see Keyvet admin'}, { root: true });
    }
    return Promise.reject(error)
}

function getConsultHistoryData(url) {
    return axios({
        method: 'get',
        url: BASE_API_URL + url,
        headers: authHeader()
    }).catch(handleResponse)
        .then(response => response.data)
}


export const consultHistoryService = {
    getConsultHistoryData,
};
